import type { PenAnchorPoint } from '@/lib/elements/types/pen-anchor-point'
import { PenSubpathRange } from '@/lib/elements/types/pen-subpath-range'

export function defaultSubpaths(
  points: PenAnchorPoint[],
  isClosed: boolean,
  subpaths: PenSubpathRange[] | undefined
): PenSubpathRange[] {
  if (subpaths && subpaths.length > 0) return subpaths

  return [{ start: 0, end: points.length, isClosed }]
}
